import type { RouteRecordRaw } from 'vue-router';

export const priceRoutes: Array<RouteRecordRaw> = [
  {
    path: '/price',
    name: 'price',
    redirect: '/price/list',
    component: () => import('pages/trade/admin/price/McPrice.vue'),
    meta: {
      title: 'Prices',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'priceList',
        component: () => import('pages/trade/admin/price/PriceList.vue'),
        meta: {
          title: 'Prices List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?',
        name: 'priceDetail',
        component: () => import('pages/trade/admin/price/PriceDetail.vue'),
        meta: {
          title: 'Price Details',
          requiresAuth: true,
        },
      },
      {
        path: 'new',
        name: 'priceNew',
        component: () => import('pages/trade/admin/price/PriceNew.vue'),
        meta: {
          title: 'New Price',
          requiresAuth: true,
        },
      },
    ],
  },
];
